import { Colors } from '../../../../themes/colors';

export const FormField = ({ label, required, children, style = {} }) => (
  <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 8, ...style }}>
    <b style={{ height: 20 }}>
      {label}
      {required && <span style={{ color: Colors.error_500 }}>*</span>}
    </b>

    {children}
  </div>
);
